import * as React from 'react';

import { StyledHeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import NativeApi from '../../../utils/nativeApi';

interface ButtonPreviewProps {
	url: string;
	isDisabled: boolean;
}

const ButtonPreview = ({ url, isDisabled }: ButtonPreviewProps) => {
	const handleClick = () => {
		if (UserAgentUtils.isMobileApp) {
			NativeApi.openFrame(url);
		} else {
			window.open(url);
		}
	};

	return (
		<StyledHeaderButton
			width="23px"
			height="25px"
			disabled={isDisabled}
			onClick={handleClick}
		>
			{Utils.getSvgIcon('iconset_uprez_eye')}
		</StyledHeaderButton>
	);
};

export default ButtonPreview;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonPreview/index.tsx